<template>
  <v-snackbar
    v-model="showInstallPrompt"
    top
    :timeout="-1"
    multi-line
  >
    Installer
    <v-btn
      class="ml-0"
      text
      @click="installerEvent.prompt()"
    >
      Install
    </v-btn>
    <v-btn
      text
      color="amber"
      @click="showInstallPrompt = false"
    >
      Fermer
    </v-btn>
  </v-snackbar>
</template>

<script>
export default {
  name: "InstallPrompt",
  data: () => ({
    showInstallPrompt: false,
    installerEvent: null
  }),
  created() {
    this.createInstaller();
  },
  methods: {
    // Handle Install Prompt
    handleInstallPrompt(event) {
      this.installerEvent = event;
      this.installerEvent.preventDefault();
      this.showInstallPrompt = true;
      this.installerEvent.userChoice.then(res => {
        console.log(res);
      });
    },

    // Create installer
    createInstaller() {
      // Add event listeners
      if (typeof window !== "undefined") {
        window.addEventListener(
          "beforeinstallprompt",
          this.handleInstallPrompt
        );
        window.addEventListener("appinstalled", () => {
          console.log("Application installed");
          this.installerEvent = null;
        });
      }
    }
  }
};
</script>

<style></style>
